import React from "react";
import styled from "styled-components";
import {
  FacebookFilled,
  TwitterCircleFilled,
  InstagramFilled,
} from "@ant-design/icons";

export const Wrapper = styled.div`
  background: #f6f6f6;
  min-height: 400px;
  .icon-container {
    display: flex;
    justify-content: center;
    height: 150px;
    align-items: center;
  }
  .icon-bg {
    height: 60px;
    width: 60px;
    font-size: 21px;
    display: grid;
    place-items: center;
    background-color: transparent;
    color: #6a6a6a;
    border: 1px solid #6a6a6a;
    border-radius: 100%;
    margin: 12px;
    transition: 0.3s all ease;
  }
  .icon-bg:hover {
    color: white;
    background: #f0394d;
    border: none;
  }
  .text-wrap {
    text-align: justify;
    display: flex;
    justify-content: center;
    padding: 0 4% 0 4%;
  }
  .text-wrap p {
    max-width: 800px;
    text-align: center;
  }
`;

export default function Content() {
  return (
    <>
      <Wrapper>
        <div className="icon-container">
          <span className="icon-bg">
            <FacebookFilled />
          </span>
          <span className="icon-bg">
            <TwitterCircleFilled />
          </span>
          <span className="icon-bg">
            <InstagramFilled />
          </span>
        </div>
        <div className="text-wrap">
          <p>
            <b>I'm Ufedo Favour.</b> Lorem ipsum dolor sit amet, consectetur
            adipiscing elit. Fusce urna urna, imperdiet et purus ut, ultricies
            sollicitudin arcu. Cras placerat, arcu non faucibus suscipit, ex
            arcu consectetur enim, eu malesuada magna turpis sit amet mauris.
            Nullam nec leo at lorem interdum commodo. Etiam mollis massa in
            mauris lacinia porta. Pellentesque tristique, ante nec dictum
            mollis, felis ligula ullamcorper velit, ac auctor est ipsum vehicula
            ex. Donec eu blandit est, id gravida justo. Maecenas laoreet laoreet
            congue. Cras sit amet vestibulum ligula. Ut nec erat tristique,
            iaculis purus ac, pellentesque mi. Donec ac cursus est. Nunc id
            varius enim, ut tincidunt mi. Integer non est eros. Aliquam ex
            magna, elementum at dignissim vitae, <br /> placerat quis ante.
            Morbi a condimentum quam. Nullam quis quam at ex eleifend feugiat.
            Vivamus lacinia quam quam, ac <br /> viverra turpis pellentesque in.
            Mauris sollicitudin sapien risus, non sagittis velit dictum eget.{" "}
            <br /> Suspendisse velit lacus, pulvinar non ante
          </p>
        </div>
      </Wrapper>
    </>
  );
}
